// extracted by mini-css-extract-plugin
module.exports = {"hero":"HeaderHero_hero__KxEu1","heroWrapper":"HeaderHero_heroWrapper__vqdPS","heroHasSearch":"HeaderHero_heroHasSearch__CDFUy"};